module.exports = __webpack_public_path__ + "static/media/Image_1_fu.b67cf115.png";